import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiStateService } from '../shared/ui-state.service';
import { PassportService } from '../shared/passport.service';

@Component({
  selector: 'app-scheduler-status-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './scheduler-status-tabs.component.html',
  styleUrl: './scheduler-status-tabs.component.css'
})
export class SchedulerStatusTabsComponent implements OnInit {
  @Input() allCount = 0;
  @Input() loadCount = 0;
  @Input() shuntingCount = 0;
  @Input() transloadingCount = 0;
  @Input() transferredCount = 0;
  @Input() showShuntingTab = true;
  @Input() showTransferredTab = true;

  constructor(public ui: UiStateService, public passports: PassportService) {}

  // Use shared UI state for tab selection
  get selected() {
    return this.ui.schedulerTabSelected;
  }

  ngOnInit(): void {
    // Initialize with 'all' tab if not already set
    if (!this.ui.schedulerTabSelected()) {
      this.ui.setSchedulerTabSelected('all');
    }
  }

  setSelected(tab: 'all' | 'load' | 'shunting' | 'transloading' | 'transferred'): void {
    this.ui.setSchedulerTabSelected(tab);
  }
}
